import {
  ADJACENT_KEYBOARD_KEYS_REGEX,
  CONSECUTIVE_CHARACTERS_REGEX,
  IDENTICAL_CHARACTERS_REGEX,
  MIN_LENGTH_REGEX,
  NUMERIC_REGEX,
  SPECIAL_CHARACTERS_REGEX,
  UPPERCASE_REGEX,
  URL_REGEX,
} from '../regex/constants';

export const isValidCase = (value: string) => {
  return {
    isUpperCase: UPPERCASE_REGEX.test(value),
  };
};

export const isValidCharacters = (value: string) => {
  return {
    isSplCharacters: SPECIAL_CHARACTERS_REGEX.test(value),
  };
};

export const isNumeric = (value: string) => {
  return {
    isNumber: NUMERIC_REGEX.test(value),
  };
};

export const isValidLength = (value: string) => {
  return {
    isMinLength: MIN_LENGTH_REGEX.test(value),
  };
};

export function checkLength(str: string) {
  const isValid = str.length >= 8;
  return isValid;
}

export function checkLowerCaseChar(str: string) {
  const isValid = /(?=.*[a-z])/.test(str);
  return isValid;
}

export function checkUpperCaseChar(str: string) {
  const isValid = /(?=.*[A-Z])/.test(str);
  return isValid;
}

export function checkNumber(str: string) {
  const isValid = /(?=.*\d)/.test(str);
  return isValid;
}

export function checkSpecialChar(str: string) {
  const isValid = /^(?=.*[\W_])[^ ]+$/.test(str);
  return isValid;
}

export function checkConsecutiveCharacters(str: string) {
  return !CONSECUTIVE_CHARACTERS_REGEX.test(str);
}

export function checkIdenticalCharacters(str: string) {
  return !IDENTICAL_CHARACTERS_REGEX.test(str);
}

export function checkAdjacentKeyboardKeys(str: string) {
  return !ADJACENT_KEYBOARD_KEYS_REGEX.test(str);
}

export const isValidURL = (url: string): boolean => {
  return URL_REGEX.test(url);
};
